<app-seamless-header></app-seamless-header>

<section  class="extra_padding_for_header">
<div class="progress-bar-custom">
    <div class="progress-bar-custom__fill"></div>
</div>

<!-- body section -->
<div [ngClass]="setPosition ? 'position-fix' : (!moved ? 'center' : 'moved')"
    class="box d-flex flex-column align-items-center justify-content-center">
    <div class="d-flex flex-column welcome-text text-center">
        <div>
            <div>{{userName}}, ready for personalised</div>
            <div>insights & solutions?</div>
        </div>
        <div class="align-self-center blue_line"></div>
        <div class="snapshot">Finish setting up your account to <div class="credit_health">make good money choices</div>
        </div>
    </div>

    <section class="full-screen-section" *ngIf="displayIncomeSection">
        <form class="capture-income-form" [formGroup]="updateIncomeForm" (ngSubmit)="finishSetup()">
            <div class="inner-section">
                <div class="mt-4 mb-3">Please enter your take-home salary</div>
                <div class="income-box">
                    <button type="button" class="info" (click)="openUpdateIncomeInfoModal()">
                        Why do you need my salary info?
                    </button>
                    <div class="input-group mt-2 mb-2">
                        <span>R</span>
                        <input class="form-control income-input-box" type="text" 
                            formControlName="GrossIncome" id="salary" (input)="onSalaryInput($event)"
                            (blur)="formatSalaryDisplay()" (keypress)="allowNumbersOnly($event)" maxlength="7"
                            isRequired="true" inputmode="numeric">
                    </div>
                     <div *ngIf="updateIncomeFormControls.GrossIncome.touched && updateIncomeFormControls.GrossIncome.errors"
                            class="invalid-feedback">
                            <div *ngIf="updateIncomeFormControls.GrossIncome.errors.required">Take-home salary is
                                required</div>
                            <div *ngIf="updateIncomeFormControls.GrossIncome.errors.min">Invalid Take-home salary</div>
                        </div>
                </div>
                <div class="list-item">
                    <li class="mb-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                            fill="none">
                            <path
                                d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967C10.9626 4.97674 10.9559 4.98424 10.9498 4.9921L7.4774 9.41674L5.38388 7.32322C5.09098 7.03033 4.61611 7.03033 4.32322 7.32322C4.03032 7.61612 4.03032 8.09099 4.32322 8.38388L6.96966 11.0303C7.26256 11.3232 7.73743 11.3232 8.03032 11.0303C8.03685 11.0238 8.043 11.0169 8.04876 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967Z"
                                fill="#222223" />
                        </svg>
                        <span class="ms-2">Find out how much credit you qualify for</span>
                    </li>
                    <li class="mb-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                            fill="none">
                            <path
                                d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967C10.9626 4.97674 10.9559 4.98424 10.9498 4.9921L7.4774 9.41674L5.38388 7.32322C5.09098 7.03033 4.61611 7.03033 4.32322 7.32322C4.03032 7.61612 4.03032 8.09099 4.32322 8.38388L6.96966 11.0303C7.26256 11.3232 7.73743 11.3232 8.03032 11.0303C8.03685 11.0238 8.043 11.0169 8.04876 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967Z"
                                fill="#222223" />
                        </svg>
                        <span class="ms-2">Learn how to improve your financial health</span>
                    </li>
                    <li class="mb-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                            fill="none">
                            <path
                                d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967C10.9626 4.97674 10.9559 4.98424 10.9498 4.9921L7.4774 9.41674L5.38388 7.32322C5.09098 7.03033 4.61611 7.03033 4.32322 7.32322C4.03032 7.61612 4.03032 8.09099 4.32322 8.38388L6.96966 11.0303C7.26256 11.3232 7.73743 11.3232 8.03032 11.0303C8.03685 11.0238 8.043 11.0169 8.04876 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967Z"
                                fill="#222223" />
                        </svg>
                        <span class="ms-2">See how much of your income repays your debt</span>
                    </li>
                </div>
                <button id="btn_userJourney_submitIncome_registration" [disabled]="salary === null || salary === undefined || salary < 0 || salary > 999999"
                    class="finishButton"
                    [class.active]="salary >= 0 && salary <= 999999 && salary !== null && salary !== undefined">
                    Finish setup
                </button>
            </div>
        </form>
    </section>
    <ng-template #updateIncomeInfoModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Why do you need my salary info?</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class='mb-2'>Your take-home salary (the amount you receive after tax) helps us understand your financial
            situation.</div>
        <div class='mb-1'>This allows us to tailor offers, insights, and solutions to meet your needs and budget.</div>
    </div>
    <div class="modal-footer">
        <button type="button" class="jm-btn-primary" (click)="modal.dismiss('Cross click')">OK, thanks!</button>
    </div>
</ng-template>
</div>
</section>
